















import Vue from 'vue'

/**
 * scrollY: scrollY のプロパティを持っていないブラウザは、pageYOffset を使用する
 * position: 現在の scrollY の値
 * scrolling: ボタンが押されてスクロール中かどうか
 */
type Data = {
  scrollY: 'scrollY' | 'pageYOffset';
  position: number;
  scrolling: boolean;
};

export default Vue.extend({
  name: 'PageTopButton',
  props: {
    top: {
      type: Number,
      default: () => 1500
    }
  },
  data (): Data {
    return {
      scrollY: 'scrollY' in window ? 'scrollY' : 'pageYOffset',
      position: 0,
      scrolling: false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      if (this.scrolling) {
        return
      }
      this.position = window[this.scrollY]
    },
    toTop () {
      if (this.scrolling) {
        return
      }
      this.scrolling = true
      const divideBy = this.position > 5000 ? 20 : 10
      const amount = Math.floor(this.position / divideBy)
      const id = setInterval(() => {
        this.position = this.position > amount ? this.position - amount : 0
        window.scrollTo(0, this.position)
        if (this.position <= 0) {
          clearInterval(id)
          this.scrolling = false
        }
      }, 20)
    }
  }
})
